<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض المدرب</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>الإسم</th>
                    <td>{{ instructor.full_name }}</td>
                  </tr>
                  <tr>
                    <th> الإسم بالعربي</th>
                    <td>{{ instructor.full_name_ar }}</td>
                  </tr>
                  <tr>
                    <th>البريد الإلكتروني</th>
                    <td>{{ instructor.email }}</td>
                  </tr>
                </table>
            </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowInstructor',
  data () {
    return {
      instructor: []
    }
  },
  created () {
    console.log(this.$route.params.id)
    this.$http
      .get(`${this.$hostUrl}instructors/${this.$route.params.id}/edit`)
      .then((response) => {
        this.instructor = response.data.data.instructor
      })
  },
  methods: {
    goBack () {
      this.instructorsOpened ? this.$router.go(-1) : this.$router.push({ path: '/instructors' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
